import {STATE_NAMES} from '../primoExplore/primoExploreStates.module';
import {PrimolyticsService, beacon} from '../analytics/primolytics.service';
import {Component, OnInit, Inject} from 'ng-metadata/core';
import { ResearchAssistantService } from "./researchAssistant.service";
import {getVid, isShowReasearcherAssistantByIcon, isShowReasearcherAssistantByWidget, getSaveUsersRaSearchHistory, isSaml} from '../appConfig/appConfigForward';
import {ConfigurationUtil} from "../nddUtils/configurationUtil.service";
import { StorageUtil } from "../infra/storageUtil.service";
import {UserSessionManagerService} from '../security/userSessionManager.service';
import {JwtUtilService} from '../security/jwtUtil.service';

const get = require('lodash/get');

@Component({
    selector: 'prm-research-assistant',
    templateUrl: 'components/researchAssistant/research-assistant.html'
})

export class PrmResearchAssistant implements OnInit{

    private apiParams: string="";
    private searchTerm: string = "";
    private webcomphtml: string = "";
    private debugMode: boolean = false;
    constructor(@Inject('I18nService') private i18nService,
                private researchAssistantService: ResearchAssistantService,
                private configurationUtil: ConfigurationUtil,
                private storageUtil: StorageUtil,
                private primolyticsService: PrimolyticsService,
                private userSessionManagerService: UserSessionManagerService,
                private jwtUtilService: JwtUtilService,
                @Inject('$state') private $state: ng.ui.IStateService,
                @Inject('$timeout') private $timeout: ng.ITimeoutService,
                @Inject('$stateParams') private $stateParams: angular.ui.IStateParamsService,
                @Inject('$sce') private $sce: ng.ISCEService) {
        this.apiParams = this.createApiParams();
        if (!this.configurationUtil.isSuprima() || (!isShowReasearcherAssistantByIcon() && !isShowReasearcherAssistantByWidget()) ) {
            this.$state.go(STATE_NAMES.SEARCH,{vid:getVid()}, {inherit:false, reload: true})
        }
    }

    ngOnInit() {
        console.log("ngOnInit...");
        this.searchTerm = typeof this.$stateParams.query  === 'undefined' ? "" : this.$stateParams.query;
        this.debugMode = typeof this.$stateParams.debug  === 'undefined' ? false : this.$stateParams.debug;

        if(this.userSessionManagerService.isGuest() || this.storageUtil.sessionStorage.getItem('allowSavingMyResearchAssistanceSearchHistory') !== null) {
            this.generateWChtml();
        } else {
            const authenticationProfile = this.jwtUtilService.getDecodedToken().authenticationProfile;
            const timeoutDelay = isSaml(authenticationProfile) ? 5000 : 500;
            this.$timeout(() => {
                this.userSessionManagerService.userDetailsPromise.then((response) => {
                    this.generateWChtml();
                });
            }, timeoutDelay);
        }
        this.initRABeacon();
    }

    private generateWChtml() {
        this.webcomphtml =
            this.$sce.trustAsHtml('<div style="padding: 10px"> ' +
                '    <cdi-research-assistant ' +
                '            id="research-assistant" ' +
                '            height="90vh" ' +
                '            library-name="Some Library" ' +
                '            client-key=' + this.researchAssistantService.getPcKey() +
                '            product="primo" ' +
                '            api-url="/primaws/rest/priv/cdi-ra" ' +
                '            api-jwt="primoExploreJwt" ' +
                '            api-params=' + this.apiParams +
                '            language=' + this.researchAssistantService.getLang() +
                '            primary-color="#0C5294" ' +
                '            secondary-color="#595959" ' +
                '            shows-toasts="true" ' +
                '            show-beta="false" ' +
                '            debug=' + this.debugMode +
                '            enable-history=' + this.enableHistory() +
                '            show-advanced="true" ' +
                '            query="' + this.searchTerm + '"> ' +
                '    </cdi-research-assistant> ' +
                '</div>');
    }

    private createApiParams() {
        return JSON.stringify({vid:this.researchAssistantService.getVid(),lang:this.researchAssistantService.getLang()});
    };

    public initRABeacon() {
        this.$timeout(() => { 
            this.sendInitBeacon();
    
            let researchAssistantElement = document.getElementById('research-assistant');
            if (researchAssistantElement) {
                researchAssistantElement.addEventListener('stats', (e) => {
                    const {detail} = e as CustomEvent;
                    this.researchAssistantService.sendRABeacon(detail);
                    if(this.$stateParams.query && ['new-session'].includes(get(detail,'action',''))){
                        // remove the query parameter from the url when starting a new session
                        this.$state.go(STATE_NAMES.RESEARCH_ASSISTANT,{vid:getVid()}, {inherit:false, reload: false});
                    }
                });
            }
        }, 1000);
    }

    private enableHistory() {
        return getSaveUsersRaSearchHistory() && this.storageUtil.sessionStorage.getItem('allowSavingMyResearchAssistanceSearchHistory');
    }
    

    private sendInitBeacon() {
        switch (this.researchAssistantService.cameFrom) {
            case 'RESEARCH_ASSISTANT_MENU':
                this.primolyticsService.doBeaconReport({
                    'p': 'researchAssistant', 'op': 'raMenuClick'
                }, {}, this.primolyticsService.getTimestamp());
                break;
            case 'RESEARCH_ASSISTANT_WIDGET':
                this.primolyticsService.doBeaconReport({
                    'p': 'researchAssistant', 'op': 'raWidgetClick'
                }, {}, this.primolyticsService.getTimestamp());
                break;
            default:
                this.primolyticsService.doBeaconReport({
                    'p': 'researchAssistant', 'op': 'raDeeplink'
                }, {}, this.primolyticsService.getTimestamp());
                break;
        }
        this.researchAssistantService.cameFrom  = '';
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/components/researchAssistant/researchAssistant.directive.ts